import { inject, Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { RestApiBase } from '../shared/configurations/rest-api-base.config';
import { iif, map, Observable, shareReplay } from 'rxjs';
import { CodeLabelEntry } from '../shared/interfaces/code-label-entry.interface';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
    providedIn: 'root',
})
export class CodeTableService {
    private http = inject(HttpClient);
    private xl8Svc = inject(TranslateService);

    getCodeTable(
        tablename: string,
        onlyEnabled = false,
        language = this.xl8Svc.currentLang,
    ): Observable<CodeLabelEntry[]> {
        let params = new HttpParams().set('tablename', tablename);

        if (language) {
            params = params.set('lang', language);
        }

        const get$ = this.http
            .get<CodeLabelEntry[]>(RestApiBase.CODE_TABLE_BASE, {
                params,
            })
            .pipe(shareReplay());
        return iif(
            () => onlyEnabled,
            get$.pipe(map((rows) => rows.filter((row) => row.enabled))),
            get$,
        );
    }
}
